export default __webpack_public_path__ + "static/media/requestedReport.dc5029c7.svg";